import { render, staticRenderFns } from "./waypoints.vue?vue&type=template&id=588caaba"
import script from "./waypoints.vue?vue&type=script&lang=js"
export * from "./waypoints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports